import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { AuthService, CacheService } from '../../auth.service';
import { BucketPipe } from '../../bucket.pipe';
import { MatIcon } from '@angular/material/icon';
import { ImageFallbackDirective } from '../../image-fallback.directive';
import { PaintDirective } from '../../paint.directive';
import { DatePipe } from '@angular/common';
import { HumanizePipe } from "../../humanize.pipe";
import { DateTime } from 'luxon';
import { RouterLink } from '@angular/router';

export interface IOfferRestriction{
    days: number;
    holidays: boolean;
}

export interface IRedemptionCard {
  _id: string;
  status: boolean;
  short_title: string;
  url: string;
  plans: string[];
  plan: string;
  userinterval: string;
  redemption: string;//redemption id

  brand: any;
  redeemed: string;
  modified: string;
  savings: number;
  actual_savings?: number;
}

@Component({
  selector: 'redemption-card',
  standalone: true,
  imports: [RouterLink, BucketPipe, DatePipe, MatIcon, ImageFallbackDirective, PaintDirective, HumanizePipe],
  templateUrl: './redemption-card.component.html',
  styleUrl: './redemption-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--offer-fill-color]': 'planColors()?.background || "#0075ff"',
    '[style.--offer-text-color]': 'planColors()?.foreground || "#ffffff"',
  }
})
export class RedemptionCardComponent {
  cache = inject(CacheService);
  auth = inject(AuthService);
  redemption = input.required<IRedemptionCard>();

  editRequest = output<string>();

  canSeeEstimated = computed(() => {
    const redemption = this.redemption();

    const has_actual_savings = !!redemption.actual_savings;
    const redeemed = DateTime.fromISO(redemption.redeemed);

    return has_actual_savings || DateTime.now().diff(redeemed, 'day').as('day') >= 7;
  })

  editable = computed(() => {
    const redemption = this.redemption();

    const has_actual_savings = !!redemption.actual_savings;
    const redeemed = DateTime.fromISO(redemption.redeemed);
    const modified = DateTime.fromISO(redemption.modified);

    const add = (!has_actual_savings && DateTime.now().diff(redeemed, 'day').as('day') < 7);
    const edit = (has_actual_savings &&  DateTime.now().diff(modified, 'days').as('day') < 1 && DateTime.now().diff(redeemed, 'day').as('day') < 8)

    return add ? 'add' : (edit ? 'edit' : null);
  });

  planColors = computed(() => this.cache.registeredPlans().find(plan => this.redemption().plan == plan.identifier)?.color_settings);

  edit(){
    this.editRequest.emit(this.redemption().redemption);
  }

}
